import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import config from 'universal-config';
import { CmsModules } from 'containers/CmsPage/CmsModules';
import * as Optimizely from 'helpers/optimizely';

export class ExperimentVariation extends PureComponent {
  shouldRender() {
    const { experimentId, isDefault, query, testVariationName, variationId } = this.props;

    if (query.use_cms_experiment_variation && config().env !== 'production') {
      return testVariationName === query.use_cms_experiment_variation;
    }

    return Optimizely.isActiveExperimentById(experimentId)
      ? Optimizely.isActiveVariationById(experimentId, variationId)
      : isDefault;
  }

  render() {
    const { modules } = this.props;

    return this.shouldRender() ? <CmsModules modules={modules} /> : null;
  }
}

ExperimentVariation.propTypes = {
  experimentId: PropTypes.string.isRequired,
  isDefault: PropTypes.bool,
  modules: PropTypes.array.isRequired,
  query: PropTypes.object.isRequired,
  testVariationName: PropTypes.string,
  variationId: PropTypes.string.isRequired,
};
